"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var executionResultHelper_1 = require("../_util/executionResultHelper");
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var color_1 = require("../_util/color");
var polished_1 = require("polished");
var HeatmapColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(HeatmapColorStrategy, _super);
    function HeatmapColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeatmapColorStrategy.prototype.getColorByIndex = function (index) {
        return this.palette[index % this.palette.length];
    };
    HeatmapColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _stackByAttribute, dv) {
        var mappedColor;
        var colorAssignment;
        var measureGroup = executionResultHelper_1.findMeasureGroupInDimensions(dv.meta().dimensions());
        var headerItem = measureGroup && measureGroup.items[0];
        if (colorMapping) {
            mappedColor = sdk_ui_vis_commons_1.getColorFromMapping(headerItem, colorMapping, dv);
            if (mappedColor) {
                colorAssignment = [
                    {
                        headerItem: headerItem,
                        color: mappedColor,
                    },
                ];
            }
        }
        colorAssignment = colorAssignment || this.getDefaultColorAssignment(colorPalette, headerItem);
        return {
            fullColorAssignment: colorAssignment,
            outputColorAssignment: colorAssignment,
        };
    };
    HeatmapColorStrategy.prototype.getThemeBackgroundColor = function () {
        var _a, _b, _c, _d, _e, _f;
        return (_c = (_b = (_a = this.theme) === null || _a === void 0 ? void 0 : _a.chart) === null || _b === void 0 ? void 0 : _b.backgroundColor) !== null && _c !== void 0 ? _c : (_f = (_e = (_d = this.theme) === null || _d === void 0 ? void 0 : _d.palette) === null || _e === void 0 ? void 0 : _e.complementary) === null || _f === void 0 ? void 0 : _f.c0;
    };
    HeatmapColorStrategy.prototype.getBackgroundColor = function () {
        var _a;
        return (_a = this.getThemeBackgroundColor()) !== null && _a !== void 0 ? _a : "#fff";
    };
    HeatmapColorStrategy.prototype.createPalette = function (colorPalette, colorAssignment) {
        var colorAssignmentColor = colorAssignment[0].color;
        if (sdk_model_1.isRgbColor(colorAssignmentColor) &&
            isEqual_1.default(colorAssignmentColor.value, color_1.DEFAULT_HEATMAP_BLUE_COLOR)) {
            return sdk_ui_vis_commons_1.normalizeColorToRGB(this.getBackgroundColor()) === "rgb(255,255,255)"
                ? color_1.HEATMAP_BLUE_COLOR_PALETTE
                : this.getCustomHeatmapColorPalette(color_1.DEFAULT_HEATMAP_BLUE_BASE_COLOR);
        }
        if (sdk_model_1.isColorFromPalette(colorAssignmentColor)) {
            var colorFromPalette = sdk_ui_vis_commons_1.getColorByGuid(colorPalette, colorAssignmentColor.value, 0);
            return this.getCustomHeatmapColorPalette(colorFromPalette);
        }
        return this.getCustomHeatmapColorPalette(colorAssignmentColor.value);
    };
    HeatmapColorStrategy.prototype.getCustomHeatmapColorPalette = function (baseColorRGB) {
        var themeBackgroundColor = this.getThemeBackgroundColor();
        var backgroundColor = this.getBackgroundColor();
        var baseColor = sdk_ui_vis_commons_1.getRgbStringFromRGB(baseColorRGB);
        var baseColorLast = polished_1.saturate(0.16, polished_1.darken(0.2, baseColor));
        if (themeBackgroundColor && !sdk_ui_theme_provider_1.isDarkTheme(this.theme)) {
            return tslib_1.__spreadArrays(this.generatePalette(baseColor, backgroundColor, 5), this.generatePalette(baseColorLast, baseColor, 3).slice(1));
        }
        else {
            return this.generatePalette(baseColor, backgroundColor, 7);
        }
    };
    HeatmapColorStrategy.prototype.generatePalette = function (colorA, colorB, steps) {
        return range_1.default(steps).map(function (step) { return sdk_ui_vis_commons_1.normalizeColorToRGB(polished_1.mix((1 / (steps - 1)) * step, colorA, colorB)); });
    };
    HeatmapColorStrategy.prototype.getDefaultColorAssignment = function (colorPalette, headerItem) {
        var hasCustomPaletteWithColors = colorPalette && sdk_ui_vis_commons_1.isCustomPalette(colorPalette) && colorPalette[0];
        if (hasCustomPaletteWithColors) {
            return [
                {
                    headerItem: headerItem,
                    color: {
                        type: "guid",
                        value: colorPalette[0].guid,
                    },
                },
            ];
        }
        return [
            {
                headerItem: headerItem,
                color: {
                    type: "rgb",
                    value: color_1.DEFAULT_HEATMAP_BLUE_COLOR,
                },
            },
        ];
    };
    return HeatmapColorStrategy;
}(sdk_ui_vis_commons_1.ColorStrategy));
exports.HeatmapColorStrategy = HeatmapColorStrategy;
//# sourceMappingURL=heatmapColoring.js.map